module.exports = __webpack_public_path__ + "img/waerme-img5v2.bd347a49.png";